var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xtx-skeleton",class:{ shan: _vm.animated, fade: _vm.fade },style:({ width: _vm.width + 'px', height: _vm.height + 'px' })},[_c('div',{staticClass:"block",style:({ backgroundColor: _vm.bg })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-718e0568","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeleton.vue
// module id = null
// module chunks = 